import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";

import { Ward } from '../models/ward.model';
import { ResponseModel } from '../models/response.model';
import { GeneralService } from './general.service';
import { HttpParams } from '@angular/common/http';
import { IdViewModel } from '../view-model/index';
import { environment } from '../../environments/environment';
import { PersistenceService } from 'angular-persistence';
import { SelectModel } from '../models/select.model';
import { MessageService } from 'primeng/components/common/messageservice';
import { SearchInfoLocation } from '../models';

@Injectable()
export class WardService extends GeneralService {
  constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(messageService, httpClient, persistenceService, environment.apiGeneralUrl, "ward");
  }

  public getWardByDistrictId(districtId?: any, provinceId?: any): Observable<ResponseModel> {
    let params = new HttpParams();
    if (districtId) params = params.append("districtId", districtId);
    if (provinceId) params = params.append("provinceId", provinceId);
    return super.getCustomApi("getWardByDistrictId", params);
  }

  async getWardByDistrictIdAsync(districtId?: any, provinceId?: any): Promise<Ward[]> {
    const res = await this.getWardByDistrictId(districtId, provinceId).toPromise();
    if (res.isSuccess) {
      const data = res.data as Ward[];
      return data;
    } else {
      return null;
    }
  }

  async getById(id: any, cols: string[]): Promise<Ward> {
    const res = await this.getAsync(id, cols);
    if (res.isSuccess) {
      const data = res.data as Ward;
      return data;
    } else {
      return null;
    }
  }

  async getSelectModelWardByDistrictIdAsync(districtId?: any, provinceId?: any): Promise<SelectModel[]> {
    const data = await this.getWardByDistrictIdAsync(districtId, provinceId);
    if (data) {
      let wards: SelectModel[] = [];
      wards.push({ label: `-- Chọn phường/xã --`, data: null, value: null });
      data.forEach(element => {
        wards.push({
          label: `${element.fullName}`,
          data: element,
          value: element.id
        });
      });
      return wards;
    } else {
      return null;
    }
  }

  public getWardByDistrictIds(districtIds: number[], arrCols: string[] = []): Observable<ResponseModel> {
    let obj = new IdViewModel();
    obj.ids = districtIds;
    obj.cols = arrCols.join(",");

    return super.postCustomApi("getWardByDistrictIds", obj);
  }

  getWardByName(name: string, districtId: number = null) {
    let params = new HttpParams();
    params = params.append("name", name);

    if (districtId) {
      params = params.append("districtId", districtId + "");
    }

    return super.getCustomApi("getWardByName", params);
  }

  SearchAddressByPDW(keyWord: string, type?: any, provinceId?: any, districtId?: any, toHubId?: any) {
    let params = new HttpParams();
    if (keyWord) params = params.append("keyWord", keyWord);
    params = params.append("type", type);
    params = params.append("provinceId", provinceId);
    if (districtId) params = params.append("districtId", districtId);
    if (toHubId) params = params.append("toHubId", toHubId);
    return super.getCustomApi("SearchAddressByPDW", params);
  }

  async SearchAddressByPDWAsync(keyWord: string = null, type: any = null, provinceId: any = null, districtId: any = null, toHubId: any = null) {
    let res = await this.SearchAddressByPDW(keyWord, type, provinceId, districtId, toHubId).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  getAddressByPDW(provinceId?: any, districtId?: any) {
    let params = new HttpParams();
    params = params.append("provinceId", provinceId);
    params = params.append("districtId", districtId);
    return super.getCustomApi("SearchAddressByPDW", params);
  }

  async getAddressByPDWAsync(districtId?: any, wardId?: any): Promise<SearchInfoLocation[]> {
    const res = await this.getAddressByPDW(districtId, wardId).toPromise();
    if (res.isSuccess) {
      return res.data;
    } else {
      return null;
    }
  }

  async getWardByNameAsync(name: string, districtId?: number): Promise<Ward> {
    const res = await this.getWardByName(name, districtId).toPromise();
    if (res.isSuccess) {
      const data = res.data as Ward;
      return data;
    } else {
      return null;
    }
  }
}
